<template>
  <div>
    <!-- <h2 class="title_name fplist">发票列表</h2> -->
    <div class="financing">
      <!-- <div class="formSearch">
        <Search
          :tableSearch="tableSearch"
          :startSearch="isQueryData"
          :showEndDate="false"
          @handleSearch="handleSearch"
          @handleReset="handleReset"
        ></Search>
      </div> -->

      <div class="diLinkCard">
        <Search
          :tableSearch="tableSearch"
          :startSearch="isQueryData"
          :showEndDate="false"
          @handleSearch="handleSearch"
          @handleReset="handleReset"
        ></Search>
        <el-card class="box-card dcard" shadow="none">
          <Rectangle
            name="查询结果"
            :path="require('@/assets/img/common/rectangle.png')"
          />
          <div class="clearfix hjfp">
            <span>
              合计发票金额：
              <span style="color: red; font-weight: 600">{{
                hjtotalAmount | moneyFLoatFormat
              }}</span>
            </span>
            <iconBtn
              @btnClick="handleExport"
              :name="'导出'"
              :path="
                require('@/assets/img/supplier/mainPage-standReceived/home_icon_dc.png')
              "
              :width="75"
            />
            
          </div>
          <el-table
            v-loading="loading"
            :data="tableData"
            style="width: 100%"
          >
            
            <el-table-column
              align="center"
              prop="invoiceNumber"
              label="发票号码"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="invoiceCode"
              label="发票代码"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="invoiceAmout"
              label="发票金额（含税）"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="tax"
              label="发票税额"
            ></el-table-column>

            <el-table-column
              align="center"
              prop="invoiceDate"
              label="开票日期"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="holderName"
              label="供应商名称"
            ></el-table-column>
            <el-table-column align="center" label="操作">
              <template slot-scope="scope">
                <el-button @click="handleClick(scope.row)" type="text"
                  >详情</el-button
                >
              </template>
            </el-table-column>
          </el-table>
          <Pagination
            :page="pageObj"
            v-if="Number(pageObj.total) > 0"
            @setcurrentpage="setpage"
          ></Pagination>
        </el-card>
      </div>
    </div>
  </div>
</template>

<script>
import Rectangle from "@/components/public/Element/rectangle.vue";
import Pagination from "@/components/public/Element/Pagination";
import iconBtn from "@/components/public/Element/ELIconButton.vue";
export default {
  components: {
    Rectangle,
    Pagination,
    iconBtn
  },
  created() {
    // this.voucherNo = this.$route.query.id;
  },
  data() {
    return {
      isLoading: false,
      loading: false,
      params: {},
      page: {
        total: 0,
        currentPage: 1,
        size: "10",
      },
      totalElements: 0,
      totalAmount: "0",
      hjtotalAmount: '0',
      tableSearch: [
        {
          label: "发票号码",
          value: "invoiceNumber",
          type: "text",
        },
        {
          label: "发票代码",
          value: "invoiceCode",
          type: "text",
        },

        {
          type: "date",
          label: "开票日期",
          apply: "date",
          children: [
            {
              value: "STARTKPRQ",
              type: "startDate",
            },
            {
              value: "ENDKPRQ",
              type: "endtDate",
            },
          ],
        },
      ],
      tableData: [
        // {
        //   invoiceNumber: 'no01',
        //   invoiceCode: 'code01',
        //   invoiceAmout: '100',
        //   tax: '0.1',
        //   invoiceDate: '2022-02-02',
        //   status: 'byd01'
        // }
      ],
      pageObj: {page: 1, total: 0},
      selecteRowList: [],
      voucherNo: "",
      isQueryData: false
    };
  },
  methods: {
    //发票列表导出
    handleExport() {
      let params = {
          filterData: {...this.params}
        };
        const url = this.$BASEURL + "/bs/invoice/invoicePool/export";
        this.$exportFileFunc("发票列表导出结果", ".xlsx", url, "post", params);
    },
    getFpListData (para={}) {
      this.loading = true
      this.tableData = []
      this.$POST('/bs/invoice/queryInvoiceList', {
        filterData: {...para},
        pageData: {
          page: this.pageObj.page,
          pageSize: 10
        }
        // STARTKPRQ: '',
        // ENDKPRQ: '',
        // ...para
      }).then(res => {
        console.log('getFpListData-res',res)
        if (res && res.ret == '0') {
          this.tableData = res.data && res.data.content ? JSON.parse(JSON.stringify(res.data.content)) : []
          this.tableData.forEach(el => {
            el.amount = el.invoiceAmout
            el.tax2 = el.tax
            el.invoiceAmout = this.$utif.moneyFLoatFormat(el.invoiceAmout)
            el.tax = this.$utif.moneyFLoatFormat(el.tax)
            el.invoiceDate = this.$utif.cliceTime(el.invoiceDate)
            // el.status = (el.isUsed === "1")?"已使用":"未使用"
          })
          this.pageObj.total = res.data.totalElements
          this.hjtotalAmount = res.data.totalAmount ? res.data.totalAmount : '0'
        }
      }).catch(err => {
        console.log('err',err)
      }).finally(() => {
        this.loading = false
      })
    },
    handleClose() {
      this.$router.back();
    },
    handleReset () {
      //重置
      this.params = {}
      this.pageObj.total = 0
      this.hjtotalAmount = '0'
      this.tableData = []
      // console.log('reset', this.params)
      this.handleSearch(this.params)
    },
    handleSearch(val) {
      console.log('val0825',val)
      if (!val.invoiceCode && !val.invoiceNumber && !val.STARTKPRQ && !val.ENDKPRQ) {
        this.$message.warning('请输入发票号码')
        return
      }

      // if (val.invoiceCode || val.invoiceNumber) {
      //   if (!val.invoiceCode) {
      //     this.$message.warning('请输入发票代码')
      //     return
      //   }
      //   if (!val.invoiceNumber) {
      //     this.$message.warning('请输入发票号码')
      //     return
      //   }
      // }
      if (val.STARTKPRQ || val.ENDKPRQ) {
        if (!val.STARTKPRQ) {
          this.$message.warning('请选择开票开始日期')
          return
        }
        if (!val.ENDKPRQ) {
          this.$message.warning('请选择开票结束日期')
          return
        }
        const startDate = val.STARTKPRQ.slice(0, 10).replace(/[-]/g, '')
        const endDate = val.ENDKPRQ.slice(0, 10).replace(/[-]/g, '')
        const threeMon = this.$utif.getAddedMonth(val.STARTKPRQ, 3).slice(0, 10).replace(/[-]/g, '')
        if (Number(startDate) > Number(endDate)) {
          this.$message.warning('开始日期不能大于结束日期')
          return
        }
        //只允许查3个月间隔内的发票
        if (Number(endDate) > Number(threeMon)) {
          this.$message.warning('只允许查询3个月间隔内的发票')
          return
        }
      }
      // this.params = val;
      this.pageObj.page = 1;
      // const lifnrs = JSON.parse(sessionStorage.getItem("company")).sapCode
      let finalParams = {
        // BUKRS: _arr,//总公司代码
        // LIFNRS: ["108408"],//供应商代码
        // LIFNRS: [lifnrs],
        // STARTKPRQ: val.STARTKPRQ ? val.STARTKPRQ : '',
        // ENDKPRQ: val.ENDKPRQ ? val.ENDKPRQ : ''
      }
      if (val.STARTKPRQ) {
        finalParams.invoiceDateSt = val.STARTKPRQ
      } else {
        delete finalParams.invoiceDateSt
      }
      if (val.ENDKPRQ) {
        finalParams.invoiceDateEnd = val.ENDKPRQ
      } else {
        delete finalParams.invoiceDateEnd
      }
      if (val.invoiceCode) {
        finalParams.invoiceCode = val.invoiceCode
      } else {
        delete finalParams.invoiceCode
      }
      if (val.invoiceNumber) {
        finalParams.invoiceNumber = val.invoiceNumber
      } else {
        delete finalParams.invoiceNumber
      }
      console.log('finmal444',finalParams,val)
      this.params = {...finalParams}
      this.getFpListData(this.params)
    },
    handleClick(row){
      console.log("row -----0825",row);
      this.$router.push({
        path: "/supplier/ticket-list-detail",
        query: {
           row
        }
       }
      )
    },
    setpage(pageNum) {
      this.pageObj.page = pageNum;
      this.getFpListData(this.params);
    }
  },
};
</script>

<style lang="less" scoped>
.fplist {
  padding-left: 50px;
}
.hjfp {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.financing {
  // padding: 20px 50px;
  // background: white;
  // width: 90%;
  // margin: 10px auto;

  // padding: 10px 40px;
  .formSearch {
    margin-bottom: 30px;
  }
}

::v-deep .el-button--primary {
  background: #1b5bbf;
  width: 112px;
  height: 44px;
  font-size: 16px;
}
.close {
  // color: #858692;
  color: #fff;
  font-size: 16px;
}

::v-deep .diLinkTable{
  box-shadow: none;
}
</style>